import FilmDetail from "./FilmDetail";

export default FilmDetail